



























































import Vue from "vue";
import { mapGetters } from "vuex";
import { humanReadableDate, isoDate } from "@/helperFunctions";
import { db, storage, storageBase } from "@/firebase";
import { mdiContentSaveOutline, mdiClose } from "@mdi/js";
import CenterLayout from "@/components/CenterLayout.vue";
import CdsHeader from "@/components/cds/CdsHeader.vue";
import VueMarkdown from "@adapttive/vue-markdown";

export default Vue.extend({
    name: "NewEntry",
    components: {
        VueMarkdown,
        CenterLayout,
        CdsHeader,
    },
    data() {
        return {
            title: "Loading...",
            content: "",
            dateToday: humanReadableDate(new Date()),
            datePicker: isoDate(new Date()),
            datePickerDialog: false,
            dataLoaded: false,
            filename: "",
            originals: {
                title: null as string | null,
                content: null as string | null,
            },
            mdiContentSaveOutline: mdiContentSaveOutline,
            mdiClose: mdiClose,
        };
    },
    computed: {
        ...mapGetters({
            user: "user",
        }),
        prettyPrintDate(): string {
            return humanReadableDate(new Date(this.datePicker + " 00:00:00"));
        },
    },
    mounted() {
        this.filename = this.$route.params.filename;
        this.fetchFile();
    },
    methods: {
        fieldDifference() {
            return this.title !== this.originals.title ||
                this.content !== this.originals.content
                ? false
                : true;
        },
        fetchFile() {
            db.ref()
                .child(this.user.data.uid)
                .child(this.filename)
                .once("value")
                .then((snapshot) => snapshot.val())
                .then((data) => {
                    this.title = data.title;
                    this.originals.title = data.title;
                    this.datePicker = data.date;
                })
                .catch((error) => console.error(error));

            storage
                .ref()
                .child(this.user.data.uid)
                .child(`${this.filename}.md`)
                .getDownloadURL()
                .then((url) => {
                    fetch(url)
                        .then((response) => response.text())
                        .then((data) => {
                            this.content = data;
                            this.originals.content = data;
                            this.dataLoaded = true;
                        })
                        .catch((error) => console.error(error));
                })
                .catch((error) => {
                    if (error.code !== "storage/unknown") {
                        this.$router.push({
                            name: "Entries",
                            query: { error: error.code },
                        });
                    } else {
                        console.error(error.code);
                        this.title = "An unknown error occurred";
                        this.content =
                            "# " +
                            error.name +
                            ": " +
                            error.code +
                            "\n### " +
                            error.message;
                    }
                });
        },
        updateEntry() {
            let timestamp = new Date().toLocaleString();

            let databaseUpdate;
            if (this.title !== this.originals.title) {
                databaseUpdate = {
                    title: this.title,
                    last_updated: timestamp,
                };
            } else {
                databaseUpdate = {
                    last_updated: timestamp,
                };
            }
            db.ref()
                .child(this.user.data.uid)
                .child(this.filename)
                .update(databaseUpdate);

            if (this.content !== this.originals.content) {
                let file = new Blob([this.content], { type: "text/plain" }),
                    uploadTask = storage
                        .ref()
                        .child(this.user.data.uid)
                        .child(`${this.filename}.md`)
                        .put(file);

                uploadTask.on(
                    storageBase.TaskEvent.STATE_CHANGED,
                    // eslint-disable-next-line @typescript-eslint/no-empty-function
                    () => {},
                    (error) => console.error(error),
                    // eslint-disable-next-line @typescript-eslint/no-empty-function
                    () => {}
                );
            }

            this.$router.push({
                name: "View",
                params: { filename: this.filename },
                query: { source: "edit" },
            });
        },
    },
});
